export default __webpack_public_path__ + "static/media/ncx-blue-logo.a58f1e20.svg";